import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { IApiResult } from "../shared/models/api-result";
import { IWorkGroupPositionRosterType } from "../shared/models/roster/workgroup-position-rostertype";
import { ApiUrlProvider } from "./api-url.provider";

@Injectable({
  providedIn: "root"
})
export class WorkGroupPositionRosterTypeService{
  constructor(private http: HttpClient, private apiUrlProvider: ApiUrlProvider) { }
  
  getAll(): Observable<IApiResult<IWorkGroupPositionRosterType[]>>{
    return this.http.get<IApiResult<IWorkGroupPositionRosterType[]>>(`${this.apiUrlProvider.url}/WorkGroupPositionRosterType`);
  }

  add(entities: IWorkGroupPositionRosterType[]): Observable<IApiResult<IWorkGroupPositionRosterType>>{
    return this.http.post<IApiResult<IWorkGroupPositionRosterType>>(`${this.apiUrlProvider.url}/WorkGroupPositionRosterType`, entities);
  }

  delete(entity: IWorkGroupPositionRosterType): Observable<IApiResult<string>>{
    return this.http.post<IApiResult<string>>(`${this.apiUrlProvider.url}/WorkGroupPositionRosterType/delete`, entity);
  }
}